import { Component, Input, ElementRef, HostListener, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-ep-dropdown',
  templateUrl: './ep-dropdown.component.html',
  styleUrls: ['./ep-dropdown.component.scss'],
})
export class EpDropdownComponent implements OnChanges {
  @Input() value = '';
  @Input() disabled = false;
  @Input() label = '';
  public display = false;

  constructor(private _elementRef: ElementRef) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['value'] && !changes['value'].firstChange) {
      this.toggle();
    }
  }

  @HostListener('document:click', ['$event'])
  checkExternalClick($event: PointerEvent): void {
    if (this._elementRef.nativeElement.contains($event.target)) {
      if (!this.disabled) {
        this.toggle();
      } else {
        this.display = false;
      }
    } else if (!this._elementRef.nativeElement.contains($event.target)) {
      this.display = false;
    }
  }

  private toggle(): void {
    this.display = !this.display;
  }
}
